const T = require('prop-types');
const { NavLink: Link } = require('react-router-dom');
const { default: styled } = require('styled-components');
const { default: ImageListItem } = require('@mui/material/ImageListItem');
const { default: ImageListItemBar } = require('@mui/material/ImageListItemBar');
const Image = require('components/Image');
const { getSizedImageUrl } = require('utils/image');

const internals = {};

module.exports = ProfileConnectionCard;

function ProfileConnectionCard({ peer, canViewProfile, wide, onRestricted }) {

    const { Card, CardLink, RestrictedAction, NameBar, Name } = internals;
    const name = `${peer.firstName} ${peer.lastName}`;
    const content = <>
        <Image src={getSizedImageUrl(peer.croppedPicture, 400)} alt={name} ratio='1/1' placeholderBottomSpace={48} />
        <NameBar title={<Name $wide={wide}>{name}</Name>} />
    </>;

    return (
        <Card>
            {canViewProfile ? <CardLink
                to={`/app/profile/${peer.id}`}
                aria-label={`${name}'s profile`}
                data-focus-outline='radius:12,zIndex:1'
            >
                {content}
            </CardLink> : <RestrictedAction
                type='button'
                onClick={onRestricted}
                aria-label={`${name}'s profile`}
                data-focus-outline='radius:12,zIndex:1'
            >
                {content}
            </RestrictedAction>}
        </Card>
    );
}

ProfileConnectionCard.propTypes = {
    peer: T.object.isRequired,
    canViewProfile: T.bool,
    wide: T.bool,
    onRestricted: T.func.isRequired
};

internals.Card = styled(ImageListItem)`
    && {
        height: auto;
        min-width: 0;
        border-radius: 10px;
        overflow: hidden;
    }
`;

internals.CardLink = styled(Link)`
    display: block;
    position: relative;
    width: 100%;
    text-decoration: none;
`;

internals.RestrictedAction = styled.button`
    display: block;
    position: relative;
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    text-align: inherit;
    font: inherit;
    cursor: pointer;
`;

internals.NameBar = styled(ImageListItemBar)`
    && {
        bottom: 0;
    }
`;

internals.Name = styled.span`
    font-size: ${({ $wide }) => $wide ? '16px' : '12px'};
`;
